import React from 'react'
import gql from 'graphql-tag'
import { Sidebar } from 'labguard-cdk'
import { usePollingQuery } from 'src/hooks'
import NavBrand from './NavBrand'
import GroupSidebarItem from './GroupSidebarItem'

export const query = gql`
  query sidebarGroups {
    watchedGroups {
      id
      name
      channels {
        id
      }
      criticalities
      nbChannelsWithAlarm
      winkingAlarm {
        id
        toBeAcknowledged
      }
      colors @client
    }
  }
`

const GroupSidebar = () => {
  const { loading, data: { watchedGroups = [] } = {} } = usePollingQuery(query)

  return (
    <Sidebar loading={loading && !watchedGroups.length} header={<NavBrand />}>
      {watchedGroups.map(group => (
        <GroupSidebarItem key={group.id} group={group} />
      ))}
    </Sidebar>
  )
}

export default GroupSidebar
